module.exports = __webpack_public_path__ + "assets/5c711503cfcb5ffa0d6d2a07839ace97.png";